import { IsTooltipContext, Tooltip } from '@maxroll-media-group/common-libs'
import { useContext } from 'react'

export {
  ManualTooltip,
  RawTooltip,
  type TooltipAction,
  type TooltipTouchAction
} from '@maxroll-media-group/common-libs'

export const useIsTooltip = () => useContext(IsTooltipContext)

export default Tooltip
